import api from "../../../../store/AuthHeader";

const getContent = () => {
    return api.get("/Content/GetContent");
}

const getModalPopUpContent = () => {
    return api.get("/Content/GetModalPopupContent");
}

const addContent = (payload: any) => {
    return api.post("/Content", payload);
}

const updateContent = (id: number, payload: any) => {
    return api.put(`/Content/${id}`, payload);
}

export default {
    getContent,
    addContent,
    updateContent,
    getModalPopUpContent
}
